'use strict';

import http from '../../http.js';

export default {
  backendBaseUrl: global.__APP_URL__,
  injectHttp: http
};